module.exports = __webpack_public_path__ + "img/浙江恒道.10ba566f.jpg";